/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
import textStyles from '../../foundations/textStyles'

export default {
    baseStyle: {
        '--tooltip-bg': 'black',
        padding: 2,
        bg: 'var(--tooltip-bg)',
        '--popper-arrow-bg': 'var(--tooltip-bg)',
        color: 'white',
        borderRadius: 'none',
        maxW: '280px',
        mb: '9px',
        ...textStyles['Regular Medium']
    }
}
